import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {Box, FormControl, Grid, InputLabel, Select, TextField, Typography} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import './ChangeStatusLoan.css'

const ChangeStatusLoan=({openDialogLoan,handleCloseDialog,handleClickOpenDialog})=>{
    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });
    const DialogContent = withStyles((theme) => ({
        root: {
            padding: theme.spacing(2),
        },
    }))(MuiDialogContent);

    const DialogActions = withStyles((theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(1),
        },
    }))(MuiDialogActions);
    //Dialog-end
    return(
        <Dialog onClose={handleCloseDialog} aria-labelledby="customized-dialog-title" open={openDialogLoan}
                id="PersonalizedDialog">
            <DialogTitle id="customized-dialog-title" onClose={handleCloseDialog}>
                تغییر وضعیت وام
            </DialogTitle>
            <DialogContent>
                <Box className="d-flex flex-column">
                    <span>
                        بارگزاری رسید واریز وام
                    </span>
                    <div className="loan-deposit-receipt">
                        رسید واریز وام

                    </div>
                    <TextField
                        style={{marginTop:"1.5rem"}}
                        disabled
                        id="outlined-disabled"
                        label="وضعیت"
                        defaultValue="در حال بررسی"
                        variant="outlined"
                    />
                </Box>

            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCloseDialog} color="primary">
                    بروزرسانی
                </Button>
            </DialogActions>
        </Dialog>

    )
}
export default ChangeStatusLoan